import { EVerificationStatus, IVerifiedAddressData } from '@r1-frontend/entities/ContactAddress/initialState';
import { EAvailableSpeed } from '@r1-frontend/entities/ContactAddress/initialState';

import { IAddress } from '@r1-frontend/shared/types/IAddress';

export const ADDRESS_PARAM_NAME = 'addressParams';
export const MEGABIT_AVAIL_CODES_LIST = [1, 2];
export const MEGABIT_SPEED = 100;
export const GIGABIT_SPEED = 1000;

export const agreementCreationStatuses = [
    'Создаем заявку...',
    'Проверяем данные...',
    'Добавляем заявку в базу...',
    'Защищаем ваши данные...',
    'Передаем информацию...',
    'Боремся с бюрократией...',
    'Ищем свободного инженера...',
    'Проверяем доступные дату и время...',
    'Ещё немного формальностей...',
];

/**
 * Возвращает структуру IVerifiedAddressData, содержащую верифицированный адрес
 * @param storageObj - объект содержащий поля требуемые для IVerifiedAddressData
 */
export const getVerifiedAddress = (storageObj?: Record<string, string> | null): IVerifiedAddressData | null => {
    if (!storageObj) {
        return null;
    }

    const {
        address,
        gigabitAvail,
        isHouseConnected,
        status,
        companyId,

        availableSpeed,
        isHouseCottage,
    } = storageObj;

    if (status === EVerificationStatus.verified && address) {
        return {
            address: address as IAddress,
            gigabitAvail: Number(gigabitAvail),
            isPrivate: 0,
            isHouseConnected: Boolean(isHouseConnected),
            status,
            companyId: Number(companyId),

            availableSpeed: Number(availableSpeed) as EAvailableSpeed,
            isHouseCottage: Boolean(isHouseCottage),
        };
    }

    return null;
};
